import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getProductRules,
  getProductRule,
  createProductRule,
  updateProductRule,
  type CreateProductRuleRequest,
} from '../api/rules';

export function useProductRules() {
  return useQuery({
    queryKey: ['productRules'],
    queryFn: getProductRules,
  });
}

export function useProductRule(urn: string) {
  return useQuery({
    queryKey: ['productRules', urn],
    queryFn: () => getProductRule(urn),
    enabled: !!urn,
  });
}

export function useCreateProductRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateProductRuleRequest) => createProductRule(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['productRules'] });
    },
  });
}

export function useUpdateProductRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ urn, data }: { urn: string; data: Partial<CreateProductRuleRequest> }) =>
      updateProductRule(urn, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['productRules'] });
    },
  });
}
